var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7382 11.1577V23.1577C46.7382 23.7545 46.5011 24.3267 46.0792 24.7487C45.6572 25.1707 45.0849 25.4077 44.4882 25.4077C43.8915 25.4077 43.3192 25.1707 42.8972 24.7487C42.4753 24.3267 42.2382 23.7545 42.2382 23.1577V16.5952L28.0801 30.7552C27.871 30.965 27.6227 31.1314 27.3492 31.245C27.0757 31.3585 26.7825 31.417 26.4863 31.417C26.1902 31.417 25.897 31.3585 25.6235 31.245C25.35 31.1314 25.1016 30.965 24.8926 30.7552L18.9882 24.8452L7.08008 36.7496C6.65739 37.1723 6.0841 37.4097 5.48632 37.4097C4.88855 37.4097 4.31526 37.1723 3.89257 36.7496C3.46989 36.3269 3.23242 35.7536 3.23242 35.1558C3.23242 34.5581 3.46989 33.9848 3.89257 33.5621L17.3926 20.0621C17.6016 19.8523 17.85 19.6859 18.1235 19.5723C18.397 19.4588 18.6902 19.4003 18.9863 19.4003C19.2825 19.4003 19.5757 19.4588 19.8492 19.5723C20.1227 19.6859 20.371 19.8523 20.5801 20.0621L26.4882 25.9702L39.0507 13.4077H32.4882C31.8915 13.4077 31.3192 13.1707 30.8972 12.7487C30.4753 12.3267 30.2382 11.7545 30.2382 11.1577C30.2382 10.561 30.4753 9.98868 30.8972 9.56672C31.3192 9.14477 31.8915 8.90771 32.4882 8.90771H44.4882C45.0849 8.90771 45.6572 9.14477 46.0792 9.56672C46.5011 9.98868 46.7382 10.561 46.7382 11.1577Z",
    fill: "#012448",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/TrendUp.c4f2c015520fae712b5d1fc6936f7700.svg";
export { ForwardRef as ReactComponent };